<template>
  <div class="col-12">
    <div class="forms">
      <div class="row">
        <div class="col-12">
          <InputDropdown
            :is-small="true"
            :items="voivodeships" v-model="voivodeship" placeholder="Województwo"/>
        </div>
        <div class="col-12">
          <InputDropdown
            :is-small="true"
            ref="countyInput" :items="counties" v-model="county" placeholder="Powiat"/>
        </div>
        <div class="col-12">
          <InputDropdown
            :is-small="true"
            ref="communityInput" :items="communities" v-model="community" placeholder="Gmina"/>
        </div>
        <div class="col-xs-12 col-md-8">
          <InputDropdown
            :is-small="true"
            ref="cityInput" :items="cities" v-model="city" placeholder="Miejscowość"/>
        </div>
        <div class="col-xs-12 col-md-4">
          <input
            v-mask="'##-###'"
            v-model="postalCode"
            class="text-input postal-code-input"
            placeholder="Kod pocztowy"
          />
        </div>

        <div v-show="customStreetEntrance" class="col-xs-12 col-md-8" style="min-height: 64px;">
          <input v-model="customStreetName" type="text"
                 class="text-input street-input small"
                 aria-label="Niestandardowa nazwa ulicy" placeholder="Niestandardowa nazwa ulicy"/>
        </div>
        <div v-show="!customStreetEntrance" class="col-xs-12 col-md-8">
          <InputDropdown
            :is-small="true"
            ref="streetInput"
            class="street-input"
            :items="streets"
            v-model="street"
            placeholder="Ulica"/>
        </div>

        <div class="col-xs-6 col-md-2" v-show="customNumberEntrance">
          <input
            v-model="customNumber"
            type="text"
            class="text-input building-input small"
            aria-label="Numer budynku"
            placeholder="Wpisz numer budynku"
          />

        </div>
        <div
          class="col-xs-6 col-md-2"
          v-show="!customNumberEntrance"
        >
          <InputDropdown
            :is-small="true"
            ref="numberInput"
            class="street-input"
            :items="numbers"
            v-model="number"
            placeholder="Wybierz numer budynku"
          />
        </div>


        <div class="col-xs-6 col-md-2">
          <input
            v-model="localNumber"
            type="text"
            class="text-input small"
            aria-label="Numer lokalu"
            placeholder="Wpisz numer lokalu"
          />
        </div>

        <div class="col-xs-12 col-md-8">
          <label for="custom_street_checkbox">
            <input type="checkbox" id="custom_street_checkbox" v-model="customStreetEntrance">
            Nie znalazłeś swojej ulicy, wpisz ją ręcznie
            <span class="checkmark"></span>
          </label>

          <label for="custom_number_checkbox2">
            <input type="checkbox" id="custom_number_checkbox2" v-model="customNumberEntrance">
            Nie znalazłeś swojego budynku, wpisz go ręcznie
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PolishAddress from "@/mixins/PolishAddress";
import InputDropdown from "@/components/common/InputDropdown";
import Common from "@/components/declarations/validators/Common";
import PolishAddressValidation from "@/components/declarations/validators/PolishAddressValidation";

export default {
  name: "PolishAddress",
  components: {InputDropdown},
  data() {
    return {
      localNumber: "",
      errors: {}
    }
  },
  mixins: [PolishAddress, Common, PolishAddressValidation],
  methods: {
    async setData(data) {
      this.voivodeship = data.voivodeship;
      await this.getCounties();
      this.county = data.county;
      await this.getCommunities();
      this.community = data.community;
      await this.getCities();
      this.city = data.city;
      await this.getStreets();
      this.postalCode = data.postal_code;
      this.localNumber = data.premises_number;

      if (data.custom_street_name) {
        this.customStreetEntrance = true;
        this.customStreetName = data.custom_street_name;
      }
      if (data.street && data.street.id) {
        this.custom_street_name = "";
        this.street = data.street;
      }
      if (data.custom_number) {
        this.customNumberEntrance = true;
        this.customNumber = data.custom_number;
      }
      if (data.number && data.number.id) {
        await this.getNumbers();
        this.customNumber = "";
        this.number = data.number;
      }
    },
    getAddress() {
      let payload = {
        postal_code: this.postalCode,
        premises_number: this.localNumber,
        city_id: this.city.id
      };

      if (this.customStreetEntrance) {
        payload.custom_street_name = this.customStreetName;
      } else {
        payload.street_id = this.street.id;
      }

      if (this.customNumberEntrance) {
        payload.custom_number = this.customNumber;
      } else {
        payload.number_id = this.number.id;
      }
      return payload;
    }
  }
}
</script>

<style scoped>
h1, h2, h3, h4, label, p {
  color: #707070;
}

.zone-modal .forms {
  padding-top: 0 !important;
}

.postal-code-input {
  margin-top: .4rem;
  height: 2rem;
  font-size: 0.8rem;
}

.street-input {
  margin-right: 2%;
  float: left;
  margin-top: 0;
}

.col-12, .col-xs-12 {
  margin-bottom: -1.2rem;
}

.col-8, .col-md-8 {
  margin-bottom: -.8rem;
}

.building-input {
  margin-bottom: 1rem;
}

.small {
  height: 2rem;
}

@media screen and (max-width: 768px) {
  .col-12, .col-xs-12 {
    margin-bottom: 0;
  }

  .col-8, .col-md-8 {
    margin-bottom: 0;
  }

  h2 {
    font-size: 1rem;
  }
}
</style>
